import {
  BillingReadinessDetail,
  BillingReadinessResponse,
  BillingReadinessWindow,
} from '@chiroup/core/types/BillingReadiness.type';
import { useQuery } from 'react-query';
import billingReadinessService from '../services/billingReadiness.service';

const useBillingReadiness = (window: BillingReadinessWindow, enabled = true) =>
  useQuery<BillingReadinessResponse>(
    ['billing-readiness', window],
    () => billingReadinessService.list(window),
    { refetchOnWindowFocus: false, enabled }
  );

export const useBillingReadinessDetail = (
  clinicId: number | null,
  window: BillingReadinessWindow
) =>
  useQuery<BillingReadinessDetail>(
    ['billing-readiness-detail', clinicId, window],
    () => billingReadinessService.detail(clinicId as number, window),
    { refetchOnWindowFocus: false, enabled: clinicId != null }
  );

export default useBillingReadiness;
